<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-file-invoice-dollar" /> Contas a Pagar
        </h2>

        <small class="text-muted">Gerencie suas Contas a Pagar.</small>
      </div>
      <div class="col-md-6 text-right">
        <div>
          <button
            v-if="this.$acl.can('billPaymentCreateEdit')"
            class="btn btn-success"
            style="margin-left: 5px"
            @click="openInsertBillPayableForm()"
          >
            <i class="fas fa-plus" />
            <span class="d-none d-md-inline">{{ " Nova Conta a Pagar" }}</span>
          </button>
          <b-dropdown id="dropdown-1" text="Mais" class="m-md-2" right>
            <b-dropdown-item @click="openReport()"
              ><i class="fas fa-print mr-2"></i>Imprimir Relatório
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <collapse-of-the-bill-payable-filter
      v-model="searchForm"
      @filter="getBills($event)"
      ref="CollapseOfTheBillPayableFilter"
    />
    <br />
    <div class="d-none d-md-block">
      <bill-payable-stats-card />
    </div>
    <div class="row mb-5" v-if="hasSelected">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row d-flex align-items-bottom">
              <div class="col-md-2 mt-auto">
                <button
                  class="btn btn-sm btn-link text-info"
                  @click="selected = []"
                >
                  <i class="fas fa-times mr-2" />
                  <span>Limpar seleção</span>
                </button>
              </div>
              <div class="col-md-2 text-right">
                <small>Selecionado:</small>
                <br />
                <b>{{ selected.length }}</b>
              </div>
              <div class="col-md-3 text-right">
                <small>Valor:</small>
                <br />
                <b>{{ valueSum | decimal }}</b>
              </div>
              <div class="col-md-3 text-right">
                <small>Saldo Devedor:</small>
                <br />
                <b>{{ dueValueSum | decimal }}</b>
              </div>
              <div class="col-md-2 mt-auto text-right">
                <button
                  v-if="billPaymentCreateEdit"
                  class="btn btn-sm btn-success"
                  @click="pay"
                >
                  <i class="fas fa-dollar-bill" />
                  <span>Pagar Contas</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <table-paginator :data="billsPayable" @pagechange="getBills($event)">
      <div class="row grid-table-heading">
        <div class="col-md-3">Fornecedor  / Descrição </div>
        <div class="col-md-3">Plano de contas</div>
        <div
          class="col-md-3 d-flex justify-content-between mt-2 mt-md-0"
          style="padding: 0px"
        >
          <div class="col-md-6 text-right">Valor</div>
          <div class="col-md-6 text-right">Saldo Devedor</div>
        </div>
        <div
          class="col-md-3 d-flex justify-content-between mt-2 mt-md-0"
          style="padding: 0px"
        >
          <div class="col-md-5 text-right">Vencimento</div>
          <div class="col-md-5 text-center">Status</div>
          <div class="col-md-2"></div>
        </div>
      </div>
      <hr />

      <template v-for="row in billsPayable.data">
        <div
          class="row grid-table-row"
          :key="row.id"
          @click="openStoreBillPayableForm(row.id)"
        >
          <div></div>
          <div class="col-md-3 d-flex">
            <div style="width: 10%" @click.stop>
              <b-form-checkbox
                v-if="row.status == 'o' && billPaymentCreateEdit"
                @click.stop
                :value="row"
                v-model="selected"
              />
            </div>
            <div style="width: 90%">
              <template v-if="row.person_id">
                <span>{{ row.name }}</span
                ><span v-if="row.vendor_description">
                  {{ row.vendor_description }}  | {{ row.description }}</span
                >
              </template>
              <template v-else>
                <span>{{ row.vendor_description }}</span>
              </template>
              <br />
              <small class="text-muted">Documento: {{ row.document }}</small>
            </div>
          </div>
          <div class="col-md-3">{{ row.account_plan_description }}</div>

          <div
            class="col-md-3 d-flex justify-content-between mt-2 mt-md-0"
            style="padding: 0px"
          >
            <div class="col-6 d-flex text-right justify-content-between">
              <div>
                <small class="d-md-none d-inline">Valor:</small>
              </div>
              <div>{{ row.value | decimal }}</div>
            </div>
            <div class="col-6 d-flex text-right justify-content-between">
              <div>
                <small class="d-md-none d-inline">Valor Pago:</small>
              </div>
              <b class="text-danger">{{
                (row.value - row.received_value) | decimal
              }}</b>
            </div>
          </div>
          <div
            class="col-md-3 d-flex justify-content-between mt-2 mt-md-0"
            style="padding: 0px"
          >
            <div class="col-5 text-md-right">
              <div class="col-5 text-md-right">
                <due-date-badge ref="DueDateBadge" :date="row.due_date" />
              </div>
            </div>
            <div class="col-5 text-md-center">
              <span
                :class="['badge', 'text-white', status[row.status].class]"
                style="line-height: 1.2"
                >{{ status[row.status].text }}</span
              >
            </div>
            <div class="col-2 text-center" style="padding: 0px">
              <b-dropdown
                variant="transparent"
                right
                toggle-class="text-decoration-none ml-3"
                no-caret
              >
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v text-muted" />
                </template>
                <b-dropdown-item>
                  <i class="fas fa-search" />
                  Ver Pagamentos
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    row.status != 'c' && row.status != 'p' && billPaymentCancel
                  "
                  @click.stop="openBillReceiveCancelForm(row)"
                >
                  <i class="fas fa-ban" />
                  Cancelar
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </template>
    </table-paginator>

    <error-handler :error="error" />

    <insert-bill-payable-form
      ref="insertBillPayableForm"
      @stored="getBills(currentPage)"
    />
    <store-bill-payable-form
      ref="storeBillPayableForm"
      @stored="getBills(currentPage)"
    />
    <pay-bill-payable-form
      ref="payBillPayableForm"
      @stored="onBillPayableChange()"
    />
    <bill-payable-cancel-form
      ref="billPayableCancelForm"
      @canceled="onBillPayableChange()"
    />
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import Filters from "./../mixins/Filters.js";
import TablePaginator from "./../components/sections/TablePaginator.vue";
import PayBillPayableForm from "./../components/billPayable/forms/PayBillPayableForm";
import StoreBillPayableForm from "./../components/billPayable/forms/StoreBillPayableForm";
import BillPayableCancelForm from "./../components/billPayable/forms/BillPayableCancelForm";
import InsertBillPayableForm from "./../components/billPayable/forms/InsertBillPayableForm";
import CollapseOfTheBillPayableFilter from "./../components/billPayable/filter/CollapseOfTheBillPayableFilter";
import BillPayableStatsCard from "./../components/billPayable/sections/BillPayableStatsCard";
import DueDateBadge from "../components/ui/DueDateBadge";

export default {
  components: {
    Avatar,
    TablePaginator,
    PayBillPayableForm,
    StoreBillPayableForm,
    InsertBillPayableForm,
    BillPayableCancelForm,
    CollapseOfTheBillPayableFilter,
    BillPayableStatsCard,
    DueDateBadge,
  },

  data: function () {
    return {
      bills: {
        data: [],
      },

      searchForm: {
        search: null,
        due_date_start: null,
        due_date_end: null,
        status: ["o"],
      },

      selected: [],

      person_id: {},

      accounts: {},

      name: {},

      status: {
        o: {
          text: "Em Aberto",
          class: "badge-primary",
        },

        p: {
          text: "Pago",
          class: "badge-success",
        },

        c: {
          text: "Cancelado",
          class: "badge-danger",
        },

        r: {
          text: "Renegociado",
          class: "badge-warning",
        },
      },

      currentPage: 1,

      error: null,
    };
  },

  computed: {
    billsPayable() {
      return this.$store.state.billpayable.billsPayable;
    },

    hasSelected() {
      return this.selected.length > 0;
    },

    valueSum() {
      return this.selected.reduce(
        (total, row) => total + parseFloat(row.value),
        0
      );
    },

    dueValueSum() {
      return this.selected.reduce(
        (total, row) =>
          total + (parseFloat(row.value) - parseFloat(row.received_value)),
        0
      );
    },
    // permissions
    billPaymentCreateEdit() {
      return this.$acl.can("billPaymentCreateEdit");
    },
    billPaymentCancel() {
      return this.$acl.can("billPaymentCancel");
    },
  },

  created() {
    this.getBills();
    this.$store.commit("pageHasLoaded");
  },

  methods: {
    getBills(page = 1) {
      this.$store.commit("showLoading");
      this.searchForm.page = page;
      this.getStatsCardBillPayable();
      this.$store
        .dispatch("billpayable/getBillsPayable", this.searchForm)
        .then((response) => {
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },

    async getStatsCardBillPayable() {
      await this.$store.dispatch(
        "billpayable/getStatsBillsPayable",
        this.searchForm
      );
    },

    openInsertBillPayableForm() {
      this.$refs.insertBillPayableForm.open();
    },

    openStoreBillPayableForm(id) {
      if (this.billPaymentCreateEdit) {
        this.$refs.storeBillPayableForm.open(id);
      }
    },

    pay() {
      this.$refs.payBillPayableForm.open(this.selected);
    },

    openBillReceiveCancelForm(bill) {
      if (this.billPaymentCreateEdit) {
        this.$refs.billPayableCancelForm.open(bill);
      }
    },

    onBillPayableChange() {
      this.getBills(this.currentPage);
      this.selected = [];
    },

    openReport() {
      window.open("/contasapagar/relatorio");
    },
  },
};
</script>
